import {createFileRoute} from "@tanstack/react-router";

import {routeMessages} from "../../../messages/routes.messages";

import {DashboardPage} from "./-page/dashboard.page";

export const Route = createFileRoute("/_app/dashboard/")({
  component: DashboardPage,
  staticData: {
    meta: {
      labelDescriptor: routeMessages.dashboard,
      nav: {
        order: 1,
        visible: true,
      },
    },
  },
});
